import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '@ami/react/core';
import { ThumbConfiguration } from '../../../machines/machine';
import { OemThumbMountType } from '../../../machines/oemThumbMountType';
import MachineBoltPatternType from '../../../machines/machineBoltPatternType';

const DataItem = ({ label, children }) => (
  <div className="row">
    <label className="col-sm-4 col-form-label">{label}</label>
    <div className="col-sm-8">
      <div>{children}</div>
    </div>
  </div>
);

export class ReviewQuoteThumbMountData extends React.Component {
  static propTypes = {
    onStateChanged: PropTypes.func.isRequired,
    boltOnMountTypes: PropTypes.array,
    boltPatternTypes: PropTypes.array,
    quoteMachineThumbMountTypes: PropTypes.array,
    thumbConfiguration: PropTypes.instanceOf(ThumbConfiguration),
    machineOemThumbMount: PropTypes.string,
    boltPattern: PropTypes.string,
    boltOnMount: PropTypes.string,
    requiresThumbMount: PropTypes.bool,
  };

  setBoltPattern(boltPattern) {
    const { onStateChanged } = this.props;
    if (boltPattern) {
      if (boltPattern === MachineBoltPatternType.DoesNotHaveBoltPattern)
        onStateChanged({
          boltPattern,
          boltOnMount: null,
          machineOemThumbMount: null,
        });
      else onStateChanged({ boltPattern, machineOemThumbMount: null });
    } else
      onStateChanged({
        boltPattern,
        boltOnMount: null,
        machineOemThumbMount: null,
      });
  }

  setboltOnMount(boltOnMount) {
    const { onStateChanged } = this.props;

    if (boltOnMount)
      onStateChanged({
        boltOnMount,
        boltPattern: MachineBoltPatternType.HasBoltPattern,
        machineOemThumbMount: null,
      });
    else
      onStateChanged({
        boltOnMount,
        boltPattern: null,
        machineOemThumbMount: null,
      });
  }

  render() {
    const {
      machineOemThumbMount,
      boltPattern,
      boltOnMount,
      onStateChanged,
      boltOnMountTypes,
      boltPatternTypes,
      quoteMachineThumbMountTypes,
      thumbConfiguration,
      requiresThumbMount,
    } = this.props;

    return (
      <Fragment>
        {machineOemThumbMount &&
          thumbConfiguration &&
          (thumbConfiguration.oemThumbMount ===
            OemThumbMountType.NeverHasOemThumbMount ||
            thumbConfiguration.oemThumbMount ===
              OemThumbMountType.AlwaysHasOemThumbMount) && (
            <DataItem label="OEM Thumb Mount:">
              <div className="mt-2">
                {
                  quoteMachineThumbMountTypes.find(
                    (x) => x.id === machineOemThumbMount
                  ).label
                }
              </div>
            </DataItem>
          )}
        {thumbConfiguration &&
          quoteMachineThumbMountTypes &&
          requiresThumbMount &&
          thumbConfiguration.oemThumbMount ===
            OemThumbMountType.SometimesHasOemThumbMount && (
            <DataItem label="OEM Thumb Mount:">
              <Dropdown
                placeholder="Select an option..."
                isClearable={true}
                items={quoteMachineThumbMountTypes}
                onChange={(machineOemThumbMount) =>
                  onStateChanged({
                    machineOemThumbMount,
                    boltPattern: null,
                    boltOnMount: null,
                  })
                }
                selectedId={machineOemThumbMount}
                className="text-start"
                required
              />
            </DataItem>
          )}
        {thumbConfiguration &&
          boltPatternTypes &&
          requiresThumbMount &&
          thumbConfiguration.oemThumbMount ===
            OemThumbMountType.SometimesHasOemThumbBoltPattern && (
            <DataItem label="Bolt Pattern:">
              <Dropdown
                placeholder="Select an option..."
                isClearable={true}
                items={boltPatternTypes}
                onChange={(boltPattern) => this.setBoltPattern(boltPattern)}
                selectedId={boltPattern}
                className="mt-2 mb-2"
                required
              />
            </DataItem>
          )}
        {thumbConfiguration &&
          boltOnMountTypes &&
          requiresThumbMount &&
          thumbConfiguration.oemThumbMount ===
            OemThumbMountType.SometimesHasOemThumbBoltPattern &&
          boltPattern === MachineBoltPatternType.HasBoltPattern && (
            <DataItem label="Bolt-on Mount:">
              <Dropdown
                placeholder="Select an option..."
                isClearable={true}
                items={boltOnMountTypes}
                onChange={(boltOnMount) => onStateChanged({ boltOnMount })}
                selectedId={boltOnMount}
                className="mt-2 mb-2"
                required
              />
            </DataItem>
          )}
        {thumbConfiguration &&
          boltOnMountTypes &&
          requiresThumbMount &&
          thumbConfiguration.oemThumbMount ===
            OemThumbMountType.AlwaysHasOemThumbBoltPattern && (
            <DataItem label="Bolt Pattern:">
              <div className="mt-2">Has OEM thumb mount bolt pattern</div>
            </DataItem>
          )}
        {thumbConfiguration &&
          boltOnMountTypes &&
          requiresThumbMount &&
          thumbConfiguration.oemThumbMount ===
            OemThumbMountType.AlwaysHasOemThumbBoltPattern && (
            <DataItem label="Bolt-on Mount:">
              <Dropdown
                placeholder="Select an option..."
                isClearable={true}
                items={boltOnMountTypes}
                onChange={(boltOnMount) => this.setboltOnMount(boltOnMount)}
                selectedId={boltOnMount}
                className="mt-2 mb-2"
              />
            </DataItem>
          )}
      </Fragment>
    );
  }
}
